import { render } from "./PaginaDemo.vue?vue&type=template&id=3aaf6cdb&scoped=true"
import script from "./PaginaDemo.vue?vue&type=script&lang=js"
export * from "./PaginaDemo.vue?vue&type=script&lang=js"

import "./PaginaDemo.vue?vue&type=style&index=0&id=3aaf6cdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaf6cdb"]])

export default __exports__